import React, { createContext, useContext, useState } from 'react';

const SessionContext = createContext();

export const SessionProvider = ({ children }) => {
  const [privacyKey, setPrivacyKey] = useState(null); 
  const [userLoginType, setUserLoginType] = useState(null); 
  const [orgKey, setOrgKey] = useState(null);
  const [orgName, setOrgName] = useState(null);
  const [contact, setContact] = useState(null);
  const [leDate, setLeDate] = useState(null);
  const [sId, setSId] = useState(null);
  const [sesYear, setSesYear] = useState(null);
  const [clientCode, setClientCode] = useState(null);
  
  return (
    <SessionContext.Provider value={{  privacyKey, setPrivacyKey, userLoginType, setUserLoginType, orgKey, setOrgKey, orgName, setOrgName, contact, setContact, leDate, setLeDate, sId, setSId, sesYear, setSesYear, clientCode, setClientCode }}>
      {children}
    </SessionContext.Provider>
  );
};

export const useSession = () => {
  return useContext(SessionContext);
};
